/* eslint-disable react/no-multi-comp */
/* eslint-disable no-undef */
/* eslint-disable react/jsx-sort-props */
/* eslint-disable react/jsx-max-props-per-line */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { CustomFilterV2, TableV2, DialogDefaultV2 } from '../../../components/v2';
import * as selectorsAuth from '../../../store/auth/reducer';
import * as selectorsConvocacoes from '../../../store/convocacao/reducer';
import * as actionsConvocacoes from '../../../store/convocacao/actions';
import Formulario from './Formulario';
import * as Roles from '../../../constants/role';
import moment from 'moment';
import {
  Box,
  Typography,
  Stack,
  Button,
  DialogContentText,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import FilterListOutlinedIcon from '@mui/icons-material/FilterListOutlined';
import { renderStatus } from 'components/v2/cell-renderers/status';

const convocacaoStatusOptions = [
  { value: 'ACEITO', label: 'Aceito' },
  { value: 'AGUARDANDO', label: 'Aguardando' },
  { value: 'CANCELADA', label: 'Cancelada' },
  { value: 'EXPIRADA', label: 'Expirada' },
  { value: 'NEGADO', label: 'Negado' },
];

const Convocacao = ({ convocacacoes, convocacaoReport, authData }) => {
  const [open, setOpen] = useState(false);
  const [id, setId] = useState(null);
  const [localFilter, setLocalFilter] = useState({
    inicio: moment().subtract(1, 'month').startOf('month').valueOf(),
    fim: moment().endOf('month').valueOf(),
  });
  const [reload, setReload] = useState(false);
  const [openExport, setOpenExport] = useState(false);
  const [openFilter, setOpenFilter] = useState(false);

  const onEdit = id => {
    setOpen(true);
    setId(id);
  }

  const onAdd = () => {
    setOpen(true);
    setId(null);
  }

  const onClose = (save) => {
    setOpen(false);
    setId(null);
    if (save) {
      setReload(!reload);
    }
  }

  const isAdmin = () => authData && (authData.role === Roles.ADMIN || authData.role === Roles.SUPER_ADMIN);

  return (
    <Box>
      <Stack spacing={3}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent="space-between"
          alignItems={{ xs: 'flex-start', md: 'center' }}
          spacing={2}
        >
          <Stack spacing={2}>
            <Typography variant="h4">
              Convocação
            </Typography>
            <Stack direction="row" spacing={1.5} flexWrap="wrap">
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={onAdd}
              >
                Novo
              </Button>
              {isAdmin() && (
                <Button
                  variant="outlined"
                  startIcon={<DescriptionOutlinedIcon />}
                  onClick={() => setOpenExport(true)}
                >
                  Relatório
                </Button>
              )}
            </Stack>
          </Stack>

          <Button
            variant="outlined"
            startIcon={<FilterListOutlinedIcon />}
            onClick={() => setOpenFilter(true)}
          >
            Filtros
          </Button>
        </Stack>

        <TableV2
          useApi
          fetchUrl="convocacoes/filter"
          columns={[
            { field: 'inspetorNome', headerName: 'Inspetor', flex: 0.5 },
            { field: 'dataInicioValue', headerName: 'Data Início', width: 120 },
            { field: 'dataFimValue', headerName: 'Data Fim', width: 120 },
            { field: 'dataCriacaoValue', headerName: 'Data Criação', width: 150 },
            { field: 'jornada', headerName: 'Jornada', flex: 0.7 },
            { field: 'statusDescricao', headerName: 'Status', renderCell: (params) => renderStatus({ value: params.row.status, label: params.value }), width: 120 }
          ]}
          onEdit={onEdit}
          filterData={localFilter}
          refreshKey={reload}
        />

        <CustomFilterV2
          variant="dialog"
          open={openFilter}
          onClose={() => setOpenFilter(false)}
          title="Filtros"
          fullWidth
          fields={[
            { field: 'useDates' },
            { field: 'useInspetor', multiSelect: true, md: 12 },
            {
              field: 'useMultiSelectCustomOption',
              label: 'Status',
              key: 'convocacaoStatus',
              md: 12,
              options: convocacaoStatusOptions,
            },
          ]}
          defaultFilter={{
            inicio: moment().subtract(1, 'month').startOf('month').valueOf(),
            fim: moment().endOf('month').valueOf(),
          }}
          onFilter={filterData => {
            setLocalFilter(filterData);
            setOpenFilter(false);
          }}
        />

        <Formulario
          id={id}
          open={open}
          onClose={onClose}
          convocacacoes={convocacacoes}
          onReload={() => setReload(!reload)}
        />
        <DialogDefaultV2
          open={openExport}
          useFullScreen={false}
          handlerCancel={() => setOpenExport(false)}
          handlerConfirm={() => {
            convocacaoReport(localFilter, () => {
              setOpenExport(false);
            });
          }}
          title="Confirmação"
          confirmMessage="Sim"
          cancelMessage="Não"
        >
          <DialogContentText> Deseja baixar todas as informações filtradas? </DialogContentText>
        </DialogDefaultV2>
      </Stack>
    </Box>
  );
};

Convocacao.propTypes = {
  deleteConvocacao: PropTypes.func.isRequired,
  convocacacoes: PropTypes.array,
};

const mapStateToProps = state => ({
  convocacacoes: selectorsConvocacoes.getConvocacoes(state),
  authData: selectorsAuth.getAuth(state)
});

const mapDispatchToProps = dispatch => bindActionCreators({
  ...actionsConvocacoes
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Convocacao));